import {catalogSeo} from '~/utils/catalog-seo.mjs';
import {catalogListingSchema,serializeListingSchema} from '~/utils/listing-schema.mjs';
export function useCatalogSeo(options:any){
 const route=useRoute();
 const resolved=computed(()=>typeof options==='function'?options():options);
 const seo=computed(()=>catalogSeo({path:route.path,query:route.query,...resolved.value}));
 useSeoMeta({title:()=>seo.value.title,description:()=>seo.value.description,ogTitle:()=>seo.value.title,ogDescription:()=>seo.value.description,ogUrl:()=>seo.value.canonical,robots:()=>seo.value.noindex?'noindex, follow':'index, follow'});
 useHead(()=>{const schema=catalogListingSchema(seo.value,resolved.value);return {link:[{key:'canonical',rel:'canonical',href:seo.value.canonical}],script:schema?[{key:'catalog-listing-structured-data',type:'application/ld+json',innerHTML:serializeListingSchema(schema)}]:[]};});
 return seo;
}
